import {
  authService,
  redirectToSSO,
  useSnackbar,
  useAnalyticsProvider
} from "@oss/components";

const useLogout = (redirectParams = {}) => {
  const { enqueueSnackbar } = useSnackbar();
  const setTrackerData = useAnalyticsProvider();
  const callLogout = async () => {
    try {
      setTrackerData({ method: "logout" });
      await authService.get(`users/logout`, { withCredentials: true });
      redirectToSSO();
    } catch (error) {
      // if the logout endpoint 401 or 403, user is already logged out
      // ok to continue with logging out from app
      if (
        error.response &&
        (error.repsonse.status === 401 || error.response.status === 403)
      ) {
        redirectToSSO(redirectParams);
      } else {
        let errorString = "";
        if (error.response && error.response.errors) {
          const { errors } = error.response;
          errorString = "Error: " + errors.join(", ");
          enqueueSnackbar({
            title: "Error",
            message: errorString,
            options: {
              collapseMessage: true,
              persist: true,
              variant: "error"
            }
          });
        }
      }
    }
  };
  return callLogout;
};

export default useLogout;
